import React, { useEffect } from 'react'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { listPartnerAgents } from '../actions/partneragentActions'
//import moment from 'moment';

export default function PartnerAgentScreen() {
    const dispatch = useDispatch()

    const partnerAgentList = useSelector((state) => state.partnerAgentList);
    const { loading, partneragents, error } = partnerAgentList;

    useEffect(() => {
        if (partneragents == undefined || partneragents.length == 0) {
            dispatch(listPartnerAgents())
        }
    }, [dispatch, partneragents])

    return (
        <>
            <Header pageName="Partner Agent" />
            <LeftComponent>
                <div className="content-body">
                    <div className='container-fluid'>

                        <div className="heading-title border-none">
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="home-title float-left">
                                    </div>
                                    <div className="home-table-search float-right d-flex">
                                        <div class="input-group search-contacts" bis_skin_checked="1">
                                            {/* <form onSubmit={searchUniversity} class="ng-pristine ng-valid">
                                                <input type="text" id="searchUni" class="form-control ng-pristine ng-valid ng-empty ng-touched" placeholder="Search University" name="searchtxt" value={universityJson.searchtxt} onChange={e => handleJson(e)} /><i class="fa fa-search" aria-hidden="true" onClick={searchUniversity}></i>
                                            </form> */}
                                        </div>
                                        <div class="right-click Create-btn" bis_skin_checked="1">
                                            <Link to="/partner-agent/create" target="_blank" className="btn create-contact" >Create Partner Agent</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="inner-body">
                            <div className="row">
                                <div className="col-md-3 col-lg-2">
                                    <div className="filter-in-mob-view text-right">
                                        <input type="text" name="search" placeholder="Search Partner Agent..." />
                                        <i className="fas fa-filter mob-nav-open"></i>
                                    </div>
                                    {/* <!-- /filter-in-mob-view --> */}

                                    <div className="add-filter">
                                        <div className="filter-title  filter-title-mob">
                                            <h5>Filter Partner Agent</h5>
                                            <button className="mob-nav-open">☰</button>
                                        </div>
                                        <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                                            <div className="sticky pt-2">

                                                {
                                                    loading ? (
                                                        <>
                                                            <p>loading...</p>
                                                        </>
                                                    ) : (
                                                        partneragents ? (
                                                            (partneragents.length > 0) ? (
                                                                <p>Showing {partneragents.length} Partners Agent</p>
                                                            ) : (
                                                                <p>No partner agent Found</p>
                                                            )
                                                        ) : (
                                                            <p>No partner agent found</p>
                                                        )
                                                    )
                                                }

                                                {/* <h6><strong> All Filter</strong></h6> */}
                                                <button className="btn btn-sm btn-deep-orange"> Reset filters</button>
                                            </div>

                                            <ul className="modify-filter-title">
                                                {/* <li className="chose">Invoice</li>
                        <li>
                          <select className="form-control">
                            <option value="">--Select--</option>
                            <option value="">lorem ipsum</option>
                          </select>
                        </li>
                        <li className="chose">Lead source</li>
                        <li>
                          <select className="form-control">
                            <option value="">--Select--</option>
                            <option value="">lorem ipsum</option>
                          </select>
                        </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-9 col-lg-10">
                                    <div className="coctacts-table">
                                        <div className="table-responsive custom-scroll-right-bottum">
                                            <table className="table table-condensed ">
                                                <thead className="t-head-th-bg">
                                                    <tr>
                                                        {/* <th className="t-head-fixed"><input type="checkbox" value="check" /></th> */}
                                                        <th className="t-head-fixed">Partner Agent Id</th>
                                                        <th className="t-head-fixed">Partner Agent Name</th>
                                                        <th className="t-head-fixed">Country</th>
                                                        <th className="t-head-fixed">Contact Person</th>
                                                        <th className="t-head-fixed">Contact Person <br />Number</th>
                                                        <th className="t-head-fixed">Contact Person <br />Email</th>
                                                        <th className="t-head-fixed">Commission Percentage PG</th>
                                                        <th className="t-head-fixed">Commission Duration</th>
                                                        <th className="t-head-fixed">Commission Including <br/>GST</th>
                                                        <th className="t-head-fixed"></th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-bordered">
                                                    {
                                                        loading ? (
                                                            <tr>
                                                                <td colSpan="11">Loading...</td>
                                                            </tr>
                                                        ) : (
                                                            <>
                                                                {
                                                                    partneragents ? (
                                                                        (partneragents.length > 0) ? (
                                                                            partneragents.map((invo) => {
                                                                                var editLink = `/partner-agent/edit/${invo.Partner_Agent_Id}`
                                                                                return (
                                                                                    <tr key={invo.Partner_Agent_Id}>
                                                                                        <td>{invo.Partner_Agent_Id}</td>
                                                                                        <td>{invo.Partner_Agent} - <Link to={editLink} className="linkBlue" target="_blank">Edit</Link></td>
                                                                                        <td>{invo.Country}</td>
                                                                                        <td>{invo.Contact_Person}</td>
                                                                                        <td>{invo.Contact_Number}</td>
                                                                                        <td>{invo.Contact_Email}</td>
                                                                                        <td>{invo.Commision_Percentage_PG}</td>
                                                                                        <td>{invo.Commission_Duration}</td>
                                                                                        <td>{invo.Commision_Including_GST}</td>
    
                                                                                        <td></td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="8">No Record Exist!</td>
                                                                            </tr>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            <tr>
                                                                                <td colSpan="7">{error}</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                }
                                                            </>

                                                        )
                                                    }

                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="table-page-details">
                                            {/* <div className="row">

                                                <div className="col-md-9">
                                                    <div className="page-number">
                                                        <ul className="pagination justify-content-center">
                                                            <li className="page-item">
                                                                <a className="page-link" href="#" tabindex="-1">Previous</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">1</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">2</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">3</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">Next</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 text-center">
                                                    <div className="page-counter">
                                                        <label>
                                                            <select>
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                            </select> of <span>70</span> records</label>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LeftComponent>
        </>
    )
}
